import TradeStatistics from "features/trades/TradeDrawer/TradeStatistics";
import TradingViewChart from "common/Charts/TradingViewChart";
import {
  TIME_RANGE_START,
  TRADE_DRAWER_TIME_RANGES,
} from "@shared/common/constants";
import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { TradeDetailsContext } from "@shared/features/trades/TradeDetails.context";
import EditTradeContext from "@shared/features/trades/EditTrade/EditTrade.context";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import Flex from "common/Boxes/Flex";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

interface DrawerChartExtensionProps {
  isExtension?: boolean;
}

const TradeChart = ({ isExtension }: DrawerChartExtensionProps) => {
  const { symbol, exchange, tradeAnnotations, currentTradeMetadata } =
    useContext(TradeDetailsContext)!;
  const { isEdit, editTradeAnnotations, amountData } =
    useContext(EditTradeContext) || {};

  const annotations = isEdit ? editTradeAnnotations : tradeAnnotations;
  const { isNewLook } = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const chartHeight =
    isNewLook && isBottomNavigator ? PHONE_CHART_HEIGHT : CHART_HEIGHT;

  return (
    <ExtensionWrapper
      style={{
        padding: isExtension ? "40px 24px" : 0,
        marginBottom: isExtension ? 0 : 24,
      }}
    >
      <TradeStatistics amountData={amountData} />
      <TradingViewWrapper>
        <LoadingSpinnerOverlay
          isLoading={!currentTradeMetadata}
          hideContentWhileLoading={true}
          wrapStyle={{ height: isExtension ? "100%" : chartHeight }}
          spinnerSize="large"
          hideWithOpacity={true}
        >
          {!!currentTradeMetadata && (
            <TradingViewChart
              symbol={symbol}
              exchange={exchange}
              annotations={annotations}
              timeRanges={TRADE_DRAWER_TIME_RANGES}
              minimize={true}
              showExtendButton={true}
              defaultTimeRange={TIME_RANGE_START}
              startTimestamp={currentTradeMetadata?.open_time}
              endTimestamp={currentTradeMetadata?.close_time}
              object="Trade"
            />
          )}
        </LoadingSpinnerOverlay>
      </TradingViewWrapper>
    </ExtensionWrapper>
  );
};

export default TradeChart;

const CHART_HEIGHT = 400;
// The phone chart drops its legend and bottom bar, so it needs less height.
const PHONE_CHART_HEIGHT = 320;

const TradingViewWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 20px;
  position: relative;
`;
const ExtensionWrapper = styled(Flex)`
  height: 100%;
  width: 100%;
  flex-direction: column;
`;
